<script>
export default {
  name: 'FormField',
  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    icon: {
      type: String,
      default: '',
    },
    iconAction: {
      type: Function,
      default: () => {},
    },
    iconActive: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default: () => {},
    },
    validationMessage: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      innerValidation: this.validation,
    }
  },
  mounted() {
    const inputElement = this.$refs[this.name]
    if (inputElement && this.autofocus) {
      inputElement.focus()
    }
  },
}
</script>

<template>
  <div
    :class="{ 'inv-form-field--icon': !!icon }"
    class="inv-form-field"
  >
    <label
      :for="name"
      class="inv-label"
    >
      {{ label }}
    </label>

    <i
      v-if="!!icon"
      :class="{ 'inv-input-icon inv-input-icon--active': iconActive }"
      class="material-icons inv-input-icon"
      @click.prevent="iconAction"
    >
      {{ icon }}
    </i>

    <input
      :type="type"
      :value="value"
      :id="name"
      :name="name"
      :ref="name"
      :class="{ 'inv-input--error': innerValidation.$error }"
      :autofocus="autofocus"
      class="inv-input"
      @input="$emit('input', $event.target.value)"
      @blur="innerValidation.$touch()"
    />

    <div
      v-show="innerValidation.$error"
      class="inv-form-text inv-form-text--error"
    >
      {{ validationMessage }}
    </div>
  </div>
</template>

<style scoped>
.inv-form-field {
  height: 80px;
}

.inv-input {
  max-height: 40px;
  outline: none;
}

.inv-input:focus {
  -webkit-appearance: none;
  -webkit-box-shadow: var(--shadow-border-2) var(--color-primary--regular) inset;
  box-shadow: var(--shadow-border-2) var(--color-primary--regular) inset;
}

.inv-input--error:focus {
  -webkit-appearance: none;
  -webkit-box-shadow: var(--shadow-border-2) var(--color-error--regular) inset;
  box-shadow: var(--shadow-border-2) var(--color-error--regular) inset;
}

.inv-input-icon {
  top: 31.5px;
}
</style>
